// 添加 userInfo 到组件
const types = {
  MULTIPLEID_COORDINATE_LIST: 'MULTIPLEID_COORDINATE_LIST'
};
export default types;
// export const MULTIPLEIDS_COORDINATE_LIST = 'MULTIPLEIDS_COORDINATE_LIST';
